import { createContext, type ReactNode, useContext } from "react";
import { en } from "./messages/en";

export type MessageCatalog = typeof en;
export type Locale = "en";

const I18nContext = createContext<{ locale: Locale; t: (key: string) => string }>({
  locale: "en",
  t: (key) => key,
});

export function useTranslation() {
  return useContext(I18nContext);
}

export function getTranslator(locale: Locale) {
  const catalog = en;

  function t(key: string): string {
    const parts = key.split(".");
    let current: unknown = catalog;
    for (const part of parts) {
      if (current === undefined || current === null) return key;
      current = (current as Record<string, unknown>)[part];
    }
    return typeof current === "string" ? current : key;
  }

  return { locale, t };
}

export function I18nProvider({
  children,
  locale = "en" as Locale,
}: {
  children: ReactNode;
  locale?: Locale;
}) {
  const value = getTranslator(locale);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export { I18nContext };
